var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiversharesLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7947",
    "data-name": "Group 7947",
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 35.107,
    viewBox: "0 0 201 35.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3344",
    width: 201,
    height: 35.107,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7946",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5342",
    d: "M56.172,20.572a1.618,1.618,0,0,0,.708-1.422V2.251A1.662,1.662,0,0,0,56.172.8h4.966a1.744,1.744,0,0,0-.712,1.453v16.9a1.7,1.7,0,0,0,.712,1.422Z",
    transform: "translate(-34.587 -0.491)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5343",
    d: "M96.878,1.675,88.493,21.754,79.842.8H82.1a2.358,2.358,0,0,1,2.165,1.419l5.138,12.437L94.884,1.606a1.048,1.048,0,0,0,.068-.3.7.7,0,0,0-.238-.5h2.841a1.722,1.722,0,0,0-.676.877",
    transform: "translate(-49.161 -0.491)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5344",
    d: "M133.362,20.572V2.251A1.731,1.731,0,0,0,132.517.8h12.407V3.973a2.429,2.429,0,0,0-2.5-1.453h-5.512V9.486h5.141a1.349,1.349,0,0,0,1.148-.679v3.079a1.344,1.344,0,0,0-1.148-.677h-5.141v7.672h6.255a2.65,2.65,0,0,0,2.533-1.386v3.078Z",
    transform: "translate(-81.594 -0.491)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5345",
    d: "M194.067,20.572a4.1,4.1,0,0,1-3.583-1.791l-6.019-8.62h1.488a3.733,3.733,0,0,0,3.614-3.821,3.737,3.737,0,0,0-3.614-3.852h-3.143V19.149a1.655,1.655,0,0,0,.71,1.422H178.55a1.649,1.649,0,0,0,.711-1.422V2.251A1.691,1.691,0,0,0,178.55.8H186.9c3.989,0,6.728,2.431,6.728,5.273a5.684,5.684,0,0,1-4.16,5.071l6.629,9.43Z",
    transform: "translate(-109.938 -0.491)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5346",
    d: "M15.516,20.572a4.1,4.1,0,0,1-3.583-1.791l-6.019-8.62H7.4A3.732,3.732,0,0,0,11.016,6.34,3.736,3.736,0,0,0,7.4,2.488H4.259V19.149a1.655,1.655,0,0,0,.71,1.422H0a1.651,1.651,0,0,0,.711-1.422V2.251A1.693,1.693,0,0,0,0,.8H8.347c3.989,0,6.728,2.431,6.728,5.273a5.684,5.684,0,0,1-4.159,5.071l6.629,9.43Z",
    transform: "translate(0 -0.491)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5347",
    d: "M291.611.8V8.632h-8.033V.8h-4.357V20.6h4.357V12.649h8.033V20.6h4.356V.8Z",
    transform: "translate(-171.924 -0.491)",
    fill: "#639bce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5348",
    d: "M335.454.429,326.969,20.37h4.44l1.811-4.441h8.372l1.81,4.441h4.554L339.471.429Zm1.952,5.233,2.63,6.42h-5.261Z",
    transform: "translate(-201.323 -0.264)",
    fill: "#639bce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5349",
    d: "M386.759.8h9.051a7.886,7.886,0,0,1,5.77,2.009,6.213,6.213,0,0,1,1.7,4.525v.057a6.149,6.149,0,0,1-4.243,6.137l4.836,7.071H398.78l-4.242-6.335h-3.423V20.6h-4.356Zm8.769,9.616c2.121,0,3.337-1.132,3.337-2.8V7.557c0-1.867-1.3-2.828-3.423-2.828h-4.327v5.685Z",
    transform: "translate(-238.138 -0.491)",
    fill: "#639bce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5350",
    d: "M438.276.8V20.6h15.075V16.721H442.6V12.564h9.334V8.689H442.6V4.671H453.21V.8Z",
    transform: "translate(-269.858 -0.491)",
    fill: "#639bce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5351",
    d: "M482.288,17.258l2.574-3.083a9.081,9.081,0,0,0,5.912,2.4c1.782,0,2.856-.707,2.856-1.866v-.056c0-1.1-.679-1.669-3.987-2.518-3.988-1.018-6.563-2.121-6.563-6.052V6.029c0-3.593,2.886-5.968,6.93-5.968a11.459,11.459,0,0,1,7.354,2.517L495.1,5.859a9.292,9.292,0,0,0-5.148-1.952c-1.668,0-2.546.764-2.546,1.726v.056c0,1.3.849,1.726,4.271,2.6,4.017,1.046,6.279,2.489,6.279,5.939v.056c0,3.932-3,6.139-7.269,6.139a12.6,12.6,0,0,1-8.4-3.169",
    transform: "translate(-296.958 -0.038)",
    fill: "#639bce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5352",
    d: "M245.627,27.153c-.035.065-.072.127-.11.19a5.447,5.447,0,0,1-1.024,1.24,5.975,5.975,0,0,1-1.131.805,8.3,8.3,0,0,1-2.686.9c-.35.058-.7.1-1.057.123-.327.025-.654.023-.981.023-.414,0-.825-.029-1.238-.07a13.094,13.094,0,0,1-1.885-.329,13.31,13.31,0,0,1-2.067-.694,12.873,12.873,0,0,1-2.365-1.337c-.322-.231-.632-.477-.936-.73l-.028-.025-.009-.12c.13-.154.261-.307.392-.461l.807-.951.789-.931c.174-.206.344-.414.522-.616.145-.164.1-.148.252-.027a12.737,12.737,0,0,0,1.527,1.061,10.305,10.305,0,0,0,1.472.726,7.856,7.856,0,0,0,1.766.468c.254.037.508.06.764.078a6.5,6.5,0,0,0,.676.012,3.98,3.98,0,0,0,1.812-.458,2.154,2.154,0,0,0,.94-1,1.08,1.08,0,0,0,.093-.388,1.814,1.814,0,0,0,.007-.345c-.009-.076-.013-.123-.013-.123l-.005-.068a3.407,3.407,0,0,0-.164-.735,6.682,6.682,0,0,0-.672-1.426,5.639,5.639,0,0,0-.907-1.134c-.1-.1-.207-.2-.318-.292a5.055,5.055,0,0,0-.468-.356c-.421-.276-.853-.536-1.266-.823l-.109-.07s-.02-.017-.086-.065a10.117,10.117,0,0,1-.8-.65c-.2-.178-.379-.366-.556-.56a6.827,6.827,0,0,1-.6-.79,3.58,3.58,0,0,1-.447-1.026l0-.061.031.054a1.291,1.291,0,0,0,.244.33,2.483,2.483,0,0,0,.7.477,6.849,6.849,0,0,0,.88.357c.365.125.734.234,1.106.337.356.1.715.189,1.073.285l.066.016.038.009.035.01.085.019c.583.149,1.162.31,1.731.5a14.488,14.488,0,0,1,1.517.609,7.838,7.838,0,0,1,1.024.567,6.146,6.146,0,0,1,.731.571,4.94,4.94,0,0,1,.865,1.04,4.287,4.287,0,0,1,.484,1.131,5.832,5.832,0,0,1,.188,1.122,7.932,7.932,0,0,1,.01,1,6.276,6.276,0,0,1-.317,1.716,4.827,4.827,0,0,1-.291.7",
    transform: "translate(-141.685 -9.924)",
    fill: "#639bce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5353",
    d: "M241.224,13.468a3.541,3.541,0,0,1,.3.846l-.035-.016a1.6,1.6,0,0,0-.583-.679,4.333,4.333,0,0,0-.873-.457,15.485,15.485,0,0,0-1.647-.546c-.569-.162-1.146-.292-1.718-.445-.434-.116-.865-.244-1.292-.388l-.13-.043-.089-.032c-.15-.055-.3-.107-.451-.163a10.413,10.413,0,0,1-1.448-.648,5.3,5.3,0,0,1-1.828-1.645,4.289,4.289,0,0,1-.6-1.4,6.827,6.827,0,0,1-.171-1.143c-.019-.27-.016-.54-.014-.81a4.027,4.027,0,0,1,.042-.536c.012-.082.014-.111.015-.111l0-.039.012-.073c.015-.1.032-.2.052-.3a5.4,5.4,0,0,1,1.2-2.474,6.054,6.054,0,0,1,1.669-1.357A7.687,7.687,0,0,1,236.17.144c.3-.05.6-.086.91-.109A9.45,9.45,0,0,1,238.143,0c.354.011.709.03,1.062.065a12.856,12.856,0,0,1,1.606.258,11.777,11.777,0,0,1,3.621,1.5,11.625,11.625,0,0,1,.988.693l.043.034.011.08-.093.136q-.619.882-1.237,1.764c-.11.157-.221.314-.331.472l-.03.043-.027.037-.028.034-.022.034-.073.106q-.211.3-.424.607l-.027.037-.092.018-.115-.077L242.9,5.8l-.017-.012-.015-.01-.038-.026-.053-.035c-.3-.194-.6-.377-.909-.547a11.323,11.323,0,0,0-1.791-.806,6.95,6.95,0,0,0-2.221-.4,4.916,4.916,0,0,0-.967.078,2.578,2.578,0,0,0-1.1.471,1.511,1.511,0,0,0-.522.693,2.635,2.635,0,0,0-.142.75,2.869,2.869,0,0,0,.155,1.077,6.942,6.942,0,0,0,.733,1.519A5.915,5.915,0,0,0,237.324,10l.076.059.095.07s.129.093.2.136c.382.247.766.49,1.146.74a8.848,8.848,0,0,1,1.116.885,6.535,6.535,0,0,1,1.115,1.332",
    transform: "translate(-142.016 0)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5354",
    d: "M311.08,71.9h-1.022v6.111h1.022V77.33a1.806,1.806,0,0,0,1.507.777,2.115,2.115,0,0,0,2.052-2.293V75.8a2.115,2.115,0,0,0-2.052-2.294,1.772,1.772,0,0,0-1.507.829Zm1.264,5.324a1.332,1.332,0,0,1-1.289-1.414V75.8a1.332,1.332,0,0,1,1.289-1.414,1.314,1.314,0,0,1,1.264,1.414v.018a1.294,1.294,0,0,1-1.264,1.414",
    transform: "translate(-190.911 -44.274)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5355",
    d: "M328.142,76.3h-1.055l-1.156,3.282L324.693,76.3H323.6l1.842,4.429c-.167.377-.343.5-.628.5a1.239,1.239,0,0,1-.594-.168l-.343.746a2.015,2.015,0,0,0,1.046.276c.712,0,1.106-.335,1.458-1.248Z",
    transform: "translate(-199.252 -46.982)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5356",
    d: "M343.8,66.333h-3.334a.607.607,0,0,1,.3.591V74.03a.653.653,0,0,1-.3.609h1.9a.652.652,0,0,1-.3-.609V66.942h1.447a1.525,1.525,0,0,1,1.429,1.658,1.583,1.583,0,0,1-1.505,1.657h-.552l2.476,3.619a1.543,1.543,0,0,0,1.334.762h.705l-2.783-4.058a2.231,2.231,0,0,0,1.791-2.057,2.419,2.419,0,0,0-2.61-2.191",
    transform: "translate(-209.631 -40.843)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5357",
    d: "M363.085,69.852h-1.753a.55.55,0,0,1,.248.515V76.31a.539.539,0,0,1-.248.5h1.753a.633.633,0,0,1-.247-.5V70.367a.591.591,0,0,1,.247-.515",
    transform: "translate(-222.482 -43.01)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5358",
    d: "M375.841,69.8h-.99a.24.24,0,0,1,.076.171l-.02.114-1.924,4.592-1.81-4.363a.834.834,0,0,0-.762-.5h-.8L372.66,77.2l2.953-7.067a1,1,0,0,1,.228-.324",
    transform: "translate(-227.58 -42.98)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5359",
    d: "M392.515,69.852h-4.363a.6.6,0,0,1,.3.515v6.439l4.343-.02V75.7a.962.962,0,0,1-.846.5l-.049,0h-2.191V73.529h1.81a.426.426,0,0,1,.4.228V72.672a.444.444,0,0,1-.4.247h-1.81V70.462h1.924a.856.856,0,0,1,.877.515Z",
    transform: "translate(-238.996 -43.01)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5360",
    d: "M407.247,69.852h-2.934a.591.591,0,0,1,.247.515v5.925a.536.536,0,0,1-.247.495h1.752a.631.631,0,0,1-.247-.495V70.443h1.1a1.355,1.355,0,0,1,0,2.705h-.514l2.114,3.028a1.444,1.444,0,0,0,1.2.63h.743l-2.324-3.316a2.012,2.012,0,0,0,1.467-1.79c0-.991-.952-1.848-2.362-1.848",
    transform: "translate(-248.946 -43.01)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5361",
    d: "M429.453,66.284h-4.914a.693.693,0,0,1,.3.61V74a.741.741,0,0,1-.3.609h1.886A.655.655,0,0,1,426.12,74V70.627h2.115a.568.568,0,0,1,.5.286V69.694a.569.569,0,0,1-.5.286H426.12V66.95h2.286a1.016,1.016,0,0,1,1.048.61Z",
    transform: "translate(-261.4 -40.813)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5362",
    d: "M443.783,69.852h-2.934a.591.591,0,0,1,.247.515v5.925a.579.579,0,0,1-.247.495H442.6a.629.629,0,0,1-.249-.495V70.443h1.105a1.355,1.355,0,0,1,0,2.705h-.515l2.115,3.028a1.445,1.445,0,0,0,1.2.63H447l-2.324-3.316a2.011,2.011,0,0,0,1.467-1.79c0-.991-.953-1.848-2.362-1.848",
    transform: "translate(-271.442 -43.01)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5363",
    d: "M462.782,69.406a3.658,3.658,0,0,0,0,7.315h.038a3.657,3.657,0,0,0,0-7.315Zm.111,6.687c-1.582,0-2.381-1.885-2.381-3.219,0-1.62.952-2.858,2.133-2.858,1.581,0,2.4,1.886,2.381,3.22,0,1.619-.952,2.857-2.133,2.857",
    transform: "translate(-282.705 -42.735)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5364",
    d: "M488.2,69.852h-1.162a.59.59,0,0,1,.247.515v4.21l-4.324-4.724h-1.41a.565.565,0,0,1,.267.515V76.31a.6.6,0,0,1-.267.5h1.162a.538.538,0,0,1-.247-.5V71.148l5.467,6.02v-6.8a.608.608,0,0,1,.267-.515",
    transform: "translate(-296.502 -43.01)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5365",
    d: "M507.878,69.852H502.22V71.11a1.06,1.06,0,0,1,1.067-.61h1.143v5.791a.631.631,0,0,1-.248.495h1.733a.562.562,0,0,1-.229-.495V70.5h1.143a1.012,1.012,0,0,1,1.048.628Z",
    transform: "translate(-309.23 -43.01)",
    fill: "#bcbec0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiversharesLogoDark);
export default __webpack_public_path__ + "static/media/rivershares_logo_dark.3fcf5114d9ee5a4d3b55d38fd11e1389.svg";
export { ForwardRef as ReactComponent };